import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import qestIds from '../../../QestIds';
import getLabelConfig from './labelConfig';

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Preparation.StartDepth`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Preparation.DcpOffset`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Preparation.ZeroReading`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Measurements.Measurements.DepthReading`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Measurements.Measurements.Offset`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Measurements.Measurements.Depth`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Results.StartDepth`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Results.FinalDepth`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Results.TotalBlows`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Results.LayerBoundaries.Depth`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Results.LayerBoundaries.LayerThickness`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Results.LayerBoundaries.PenetrationRate`]: { uom: 'mm', format: { nearest: 1 } },
    },
    getLabelConfig(prefix)
  );

export default {
  [qestIds.dynamicConePenetrometer.InHouseMethod]: getConfig,
};
